import CView from '@/components/c-view'
import CPage from '@/components/c-page'
import CLoading from '@/components/c-loading'
import CContent from '@/components/c-content'
import CFooter from '@/components/c-footer'
import CTab from '@/components/c-tab'
import CImages from '@/components/c-images'
import CButton from '@/components/c-button'
import CPanel from '@/components/c-panel'
import CPanelContainer from '@/components/c-panel/container'
import CPanelTitle from '@/components/c-panel/title'
import CTitleLine from '@/components/c-title-line'
import CSwipe from '@/components/c-swipe'
import CSwipeFullpage from '@/components/c-swipe-fullpage'
import CThum from '@/components/c-thum'
import CCellContainer from '@/components/c-cell/container'
import CCell from '@/components/c-cell'
import CCellInput from '@/components/c-cell-input'
import CCellSelect from '@/components/c-cell-select'
import CNumberInput from '@/components/c-number-input'
import CForm from '@/components/c-form'
import CCounter from '@/components/c-counter'
import CNavbar from '@/components/c-navbar'
import CActionSheet from '@/components/c-action-sheet'
import CShare from '@/components/c-share'
import CCellCheckbox from '@/components/c-cell-checkbox'
import CCellItem from '@/components/c-cell-item'
import CSwiperWelf from '@/components/c-swipe-welf'

const components = [
  CView,
  CPage,
  CLoading,
  CContent,
  CFooter,
  CTab,
  CImages,
  CButton,
  CPanelContainer,
  CPanelTitle,
  CPanel,
  CSwipe,
  CSwipeFullpage,
  CThum,
  CCellContainer,
  CCell,
  CCellInput,
  CCellSelect,
  CNumberInput,
  CTitleLine,
  CForm,
  CCounter,
  CNavbar,
  CActionSheet,
  CShare,
  CCellCheckbox,
  CCellItem,
  CSwiperWelf
]
const install = function (Vue, opts = {}) {
  if (install.installed) return
  components.map(component => {
    Vue.component(component.name, component)
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install
}



// WEBPACK FOOTER //
// ./src/components/index.js